module.exports = __webpack_public_path__ + "img/sold-land.33fd6b35.jpg";